import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Request flag read by AuthInterceptor: a 404 on this request is an expected
 * outcome the caller renders itself (an empty list, a not-found card), so no
 * global error toast. Every other status keeps its interceptor handling,
 * including the forced logout on 401/403.
 */
export const SILENT_NOT_FOUND = new HttpContextToken<boolean>(() => false);

/** Request options for HttpBaseService that mark a 404 as handled by the caller. */
export function silentNotFound(): { context: HttpContext } {
  return { context: new HttpContext().set(SILENT_NOT_FOUND, true) };
}
